import { render } from "./PromotionBanner.vue?vue&type=template&id=33f20a74&scoped=true"
import script from "./PromotionBanner.vue?vue&type=script&lang=js"
export * from "./PromotionBanner.vue?vue&type=script&lang=js"

import "./PromotionBanner.vue?vue&type=style&index=0&id=33f20a74&scoped=true&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f20a74"]])

export default __exports__